import YYCollapse from './collapse'

export default YYCollapse